<template>

    <cliente-form :idBusiness="idBusiness" :idCliente="idCliente" :pag="pag" :idCompany="idCompany" :filtro="filter"></cliente-form>
</template>

<script>
    import ClienteForm from "../../../Widgets/Clientes/ClienteForm";

    export default {

        components: {ClienteForm},

        data() {
            return {
                idBusiness: this.$route.params.idBusiness,
                idCompany: this.$route.params.idCompany,
                pag: this.$route.params.pag,
                idCliente: this.$route.params.idCliente,
                filter: this.$route.params.filtro,
            }

        },
        created() {

            let action = this.idCliente ? this.$i18n.t("editar") : this.$i18n.t("nuevo");
            this.$store.dispatch('setNameRoute', action + ' ' + this.$i18n.t("cliente"));


        },
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/pages/Dashboard/Configuracion/Clientes/Cliente.vue